import actionTypes from './actionTypes'
import slideTypes from 'helpers/enums/slideTypes'

const flocabularyActions = {
	initializeFlocabularySuccess(videoData, cancelUrl = '') {
		return {
			type: actionTypes.FLOCABULARY_INITIALIZE_SUCCESS,
			videoData,
			cancelUrl,
		}
	},
	initializeFlocabularyError(error) {
		return {
			type: actionTypes.FLOCABULARY_INITIALIZE_ERROR,
			error,
		}
	},
	getResultsSuccess(payload) {
		return {
			type: actionTypes.FLOCABULARY_GET_RESULTS_SUCCESS,
			payload,
		}
	},
	getResultsError(serverError) {
		return {
			type: actionTypes.FLOCABULARY_GET_RESULTS_ERROR,
			serverError,
		}
	},
	cancelPreviewFlocabulary() {
		return {
			type: actionTypes.FLOCABULARY_CANCEL_PREVIEW_FLOCABULARY,
		}
	},
	editFlocabulary() {
		return {
			type: actionTypes.FLOCABULARY_EDIT_FLOCABULARY,
		}
	},
	videoPreview(videoId) {
		return {
			type: actionTypes.FLOCABULARY_VIDEO_PREVIEW_SELECTED,
			videoId,
		}
	},
	categoryFlocabularySelected(categorySelected) {
		return {
			type: actionTypes.FLOCABULARY_CATEGORY_FLOCABULARY_SELECTED,
			categorySelected,
		}
	},
	previewDataFetched(videoData) {
		return {
			type: actionTypes.FLOCABULARY_VIDEO_PREVIEW_DATA_FETCHED,
			videoData,
		}
	},
	previewDataFetchedError(message) {
		return {
			type: actionTypes.FLOCABULARY_VIDEO_PREVIEW_DATA_FETCHED_ERROR,
			message,
		}
	},
	videoSelect(videoId) {
		return {
			type: actionTypes.FLOCABULARY_VIDEO_SELECTED,
			videoId,
		}
	},
	saveFlocabularySuccess(redirectUrl, title) {
		return {
			type: actionTypes.FLOCABULARY_SAVE_SUCCESS,
			redirectUrl,
			slideType: slideTypes.SLIDE_TYPE_ID_FLOCABULARY,
			title,
		}
	},
	saveFlocabularyError(message) {
		return {
			type: actionTypes.FLOCABULARY_SAVE_ERROR,
			message,
		}
	},
	videoDataFetched(videoData) {
		return {
			type: actionTypes.FLOCABULARY_VIDEO_FETCHED,
			videoData,
		}
	},
	videoDataFetchedError(message) {
		return {
			type: actionTypes.FLOCABULARY_VIDEO_FETCHED_ERROR,
			message,
		}
	},
	categoriesFetched(payload) {
		return {
			type: actionTypes.FLOCABULARY_CATEGORIES_FETCHED,
			payload,
		}
	},
	categoriesFetchedError(error) {
		return {
			type: actionTypes.FLOCABULARY_CATEGORIES_FETCHED_ERROR,
			error,
		}
	},
	closeFlocabularySelected() {
		return {
			type: actionTypes.FLOCABULARY_CLOSE_SELECTED,
		}
	},
	flocabularyLimitReachedOverlayNudgeSelected() {
		return {
			type: actionTypes.FLOCABULARY_LIMIT_REACHED_OVERLAY_NUDGE_SELECTED,
		}
	},
	flocabularyLimitReachedOverlayDismissSelected() {
		return {
			type: actionTypes.FLOCABULARY_LIMIT_REACHED_OVERLAY_DISMISS_SELECTED,
		}
	},
	flocabularyWarningOverlayFinished() {
		return {
			type: actionTypes.FLOCABULARY_WARNING_OVERLAY_FINISHED,
		}
	},
	searchFlocabularyVideos(query) {
		return {
			type: actionTypes.FLOCABULARY_APPLY_SEARCH_SELECTED,
			query,
		}
	},
	getVideosNextPage() {
		return {
			type: actionTypes.FLOCABULARY_VIDEOS_NEXT_PAGE_REQUESTED,
		}
	},

}

export default flocabularyActions
